(function () {
  const SUMMARY_SELECTOR = ".pt-jm-summary-section";
  const MAIN_CONTENT_SELECTOR =
    "#judgeme_product_reviews .jm-cluster.jm-review-widget-header__main-content";

  function getJdgmStarClass(starIndex, score) {
    if (score >= starIndex) return "jdgm--on";
    if (score >= starIndex - 0.5) return "jdgm--half";
    return "jdgm--off";
  }

  function buildStars(average) {
    const score = average.toFixed(2);
    const stars = document.createElement("span");
    stars.className = "jdgm-prev-badge__stars pt-jm-summary-section__stars";
    stars.dataset.score = score;
    stars.setAttribute("role", "img");
    stars.setAttribute("aria-label", `${score} stars`);

    for (let i = 1; i <= 5; i += 1) {
      const star = document.createElement("span");
      star.className = `jdgm-star ${getJdgmStarClass(i, average)}`;
      stars.appendChild(star);
    }

    return stars;
  }

  function getSettings() {
    return window.jdgmSettings || {};
  }

  function getWidgetRoot() {
    return document.querySelector("#judgeme_product_reviews");
  }

  function getAverageDisplay(widget) {
    const root = widget || getWidgetRoot();
    return root?.querySelector(".jm-average-rating-display");
  }

  function calculateFromHistogram(widget) {
    const root = widget || getWidgetRoot();
    if (!root) return null;

    let weightedSum = 0;
    let total = 0;

    root.querySelectorAll(".jm-histogram-row").forEach((row) => {
      const rating = parseInt(
        row.querySelector(".jm-histogram-row__rating")?.textContent,
        10,
      );
      const frequency = parseInt(
        row.querySelector(".jm-histogram-row__frequency")?.textContent,
        10,
      );

      if (Number.isNaN(rating) || Number.isNaN(frequency)) return;

      weightedSum += rating * frequency;
      total += frequency;
    });

    if (total <= 0) return null;

    return { average: weightedSum / total, count: total };
  }

  function parseAverage(widget) {
    const avgText =
      getAverageDisplay(widget)?.querySelector(".jm-text")?.textContent;
    if (avgText) {
      const parsed = parseFloat(avgText);
      if (!Number.isNaN(parsed)) return parsed;
    }

    const fromHistogram = calculateFromHistogram(widget);
    if (fromHistogram) return fromHistogram.average;

    return 0;
  }

  function parseReviewCount(widget) {
    const countText =
      getAverageDisplay(widget)?.querySelectorAll(".jm-text")[1]?.textContent;
    if (countText) {
      const match = countText.match(/(\d+)/);
      if (match) return parseInt(match[1], 10);
    }

    const fromHistogram = calculateFromHistogram(widget);
    if (fromHistogram) return fromHistogram.count;

    return 0;
  }

  function formatReviewCount(average, count, widget) {
    const settings = getSettings();
    const existingText = getAverageDisplay(widget)
      ?.querySelectorAll(".jm-text")[1]
      ?.textContent?.trim();

    if (existingText) return existingText;

    const template =
      settings.badge_n_reviews_text ||
      "{{ average_rating_1_decimal }} ({{ n }} review/reviews)";
    const pluralWord =
      count === 1
        ? settings.review_widget_review_word_singular || "recenzja"
        : settings.review_widget_review_word_plural || "recenzje";

    return template
      .replace(/\{\{\s*average_rating_1_decimal\s*\}\}/g, average.toFixed(1))
      .replace(/\{\{\s*n\s*\}\}/g, String(count))
      .replace(/\{\{\s*number_of_reviews\s*\}\}/g, String(count))
      .replace(/review\/reviews/gi, pluralWord);
  }

  function buildSummarySection() {
    const widget = document.querySelector("#judgeme_product_reviews");
    const average = parseAverage(widget);
    const count = parseReviewCount(widget);

    const section = document.createElement("div");
    section.className = "pt-jm-summary-section";

    const wrapper = document.createElement("div");
    wrapper.className = "pt-jm-summary-section__wrapper";

    const averageEl = document.createElement("p");
    averageEl.className = "pt-jm-summary-section__average";
    averageEl.textContent = average.toFixed(1);

    const countEl = document.createElement("p");
    countEl.className = "pt-jm-summary-section__count";
    countEl.textContent = formatReviewCount(average, count, widget);

    wrapper.appendChild(averageEl);
    wrapper.appendChild(buildStars(average));
    wrapper.appendChild(countEl);
    section.appendChild(wrapper);

    return section;
  }

  function injectSummary() {
    const mainContent = document.querySelector(MAIN_CONTENT_SELECTOR);
    if (!mainContent) return false;

    const widget = document.querySelector("#judgeme_product_reviews");
    const average = parseAverage(widget);
    const count = parseReviewCount(widget);
    const countText = formatReviewCount(average, count, widget);
    const averageText = average.toFixed(1);
    const scoreText = average.toFixed(2);

    const existing = mainContent.querySelector(SUMMARY_SELECTOR);
    if (
      existing &&
      existing.querySelector(".pt-jm-summary-section__average")?.textContent ===
        averageText &&
      existing.querySelector(".pt-jm-summary-section__count")?.textContent ===
        countText &&
      existing.querySelector(".pt-jm-summary-section__stars")?.dataset.score ===
        scoreText
    ) {
      return true;
    }

    if (existing) existing.remove();

    mainContent.insertBefore(buildSummarySection(), mainContent.firstChild);
    return true;
  }

  function observeWidget() {
    const root = document.querySelector("#judgeme_product_reviews");
    if (!root) return;

    const run = () => {
      injectSummary();
    };

    run();

    const observer = new MutationObserver(run);
    observer.observe(root, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", observeWidget);
  } else {
    observeWidget();
  }
})();
